import './style.css';
import 'flowbite/dist/flowbite.js';
import './sidebar';
import './charts';
import './dark-mode';
import './assistant';

// Have the courage to follow your heart and intuition.
